module.exports = __webpack_public_path__ + "static/media/Rossmann_Regular.32acee11.woff2";